export default class WeatherWidget {
    container;
	cityId;
	appId = "7b090b65eb72fb87741f4e1f19dc3f86";
	units;
	
    constructor(id, cityId, units = 'metric') {
        this.container = document.getElementById(id);
		this.cityId = cityId;
		this.units = units;
		if(this.container && this.cityId ){
			this.show();
		}
    }

    show() {
      
        if (this.container) {
         // console.log(php_vars.php_lang)
          var str;
          var weather_name;
          if(php_vars.php_lang=='en'){
            str = "Weather in";
            weather_name = "thessaloniki"
          }else if(php_vars.php_lang =='el'){
            str = "Ο καιρός στην"
            weather_name = "θεσσαλονικη"
          }
            this.getWeather().then(weather => {
                const weatherWidget =
                    `<div class="weather-widget"><span class="typed d-none d-lg-inline"> ${str} ${weather_name}</span>
					<img class="icon" width="40" height="40" src="/wp-content/themes/zeusisloose_theme/assets/img/weather/${weather.icon}.svg" alt="">
					<span class="temprature">${weather.temprature} °C / ${weather.atmosphere}</span>
				</div>`;
                this.container.innerHTML = weatherWidget;
            });
        }
    };

    getWeather() {
        const endpoint = "https://api.openweathermap.org/data/2.5/weather"
        const url = endpoint + "?id=" + this.cityId + "&appid=" + this.appId + "&units=" + this.units;

        return fetch(url).then(response => {
            return response.json();
        }).then((weatherData) => {
            return {
				name: weatherData.name,
                temprature: parseInt(weatherData.main.temp, 10),
                atmosphere: weatherData.weather[0].description,
                icon: weatherData.weather[0].icon,
            };
        });
    }
}